import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/analytics/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/navbars/NotificationIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/app/src/components/layout/toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RespIcon"] */ "/app/src/components/responsibles/ListResponsibles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/search/SearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/app/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/i18n/i18n-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nToggle"] */ "/app/src/i18n/i18n-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MonitoringDispatcher"] */ "/app/src/monitoring/MonitoringDispatcher.tsx");
